import e from"exenv";const r=()=>!e.canUseDOM&&process.env.SERVER_API_URL?process.env.SERVER_API_URL:process.env.API_URL;export{r as determineApiUrl};
